<div class="navigation" [ngClass]="{'navigation-scroll':pageScrolled, 'navigation-dark':openMenu}">
  <div class="nowrap">
    <div class="d-inline-b logo-wrapper" [ngClass]="{'logo-wrap':pageScrolled}">
      <img src="/assets/img/logo-blue.png" class="logo-img" [ngClass]="{'logo-img-scroll':pageScrolled}">
    </div>
  </div>

  <div class="menu-wrapper" [ngClass]="{'menu-hide': !openMenu, 'padding-menu': openMenu}">
    <div class="menu-item"><a (click)="scroll('homepage'); openMenu=false">{{"Homepage"|translate}}</a></div>
    <div class="menu-item"><a (click)="scroll('who-we-are'); openMenu=false">{{"Soluzioni"|translate}}</a></div>
    <div class="menu-item"><a (click)="scroll('mission-vision'); openMenu=false">{{"Mission and vision"|translate}}</a></div>
    <div class="menu-item"><a (click)="scroll('offered-services'); openMenu=false">{{"Cosa offriamo"|translate}}</a></div>
    
    <div class="menu-item"><a (click)="scroll('projects-important'); openMenu=false">{{"Progetti"|translate}}</a></div>
    <div class="menu-item"><a (click)="scroll('our-customers'); openMenu=false">{{"Clienti"|translate}}</a></div>
    <div class="menu-item"><a (click)="scroll('about-us'); openMenu=false">{{"Dicono di noi"|translate}}</a></div>
    <div class="menu-item"><a (click)="scroll('history'); openMenu=false">{{"La storia"|translate}}</a></div>
    <div class="menu-item"><a (click)="scroll('contacts'); openMenu=false">{{"Contatti"|translate}}</a></div>
    <div class="menu-item white" (click)="showModalChangeLang()">
      <img [src]="getFlag()" height="20">
    </div>
  </div>


  <img [src]="openMenu?'./assets/img/close-white.svg':'./assets/img/menu.svg'" height="20" class="mr-4 menu-icon cursor"
    (click)="openMenu=!openMenu">
</div>

<div class="modal modal-lang" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <!-- <div class="modal-title">
          <img class="cursor" src="assets/img/close.svg" width="10" data-dismiss="modal">
        </div> -->
        <div class="modal-text">
          <div *ngFor="let l of languages; let last = last" class="white text-center  cursor" 
          (click)="changeLang(l)" [ngClass]="{'mb-4': !last}">
            <img [src]="getFlag(l)" width="100%" class="flag-modal">
          </div>
        </div>
      </div>
      <!-- <div class="modal-footer">
        <div class="button btn-white-sm text-uppercase" data-dismiss="modal">OK</div>
      </div> -->
    </div>
  </div>
</div>